import React from "react"
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography} from "@mui/material"

function ConfirmationDialog({
	onCancel,
	onOK,
	isOpen,
	title = "Confirmation",
	okLabel = "Ok",
	okEndIcon,
	description,
}: {
	onCancel: () => void
	onOK: () => void
	isOpen: boolean
	title?: string
	okLabel?: string
	okEndIcon?: React.ReactNode
	description: React.ReactNode
}) {
	return (
		<Dialog sx={{"& .MuiDialog-paper": {width: "80%", maxHeight: "50%"}}} maxWidth="xs" open={isOpen}>
			<DialogTitle align="center">{title}</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body2" display="block">
					{description}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel}>Cancel</Button>
				<Button onClick={onOK} endIcon={okEndIcon}>
					{okLabel}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export {ConfirmationDialog}
